/**
 * Polling hooks for the public activity endpoints — backs the live ticker
 * on EntryView and the in-game ActivityFeedPanel (SidePanels.tsx). Both
 * start `null`/empty and fill in once the first fetch resolves; callers are
 * expected to render nothing until then rather than a "0 online" flash.
 */

import { useEffect, useState } from 'react';
import { activityClient, type ActivityEvent } from './activity-client';

/** Generous on purpose — this is decorative, not data anyone is waiting on. */
const POLL_MS = 30_000;

export function useOnlineCount(): number | null {
  const [count, setCount] = useState<number | null>(null);

  useEffect(() => {
    let cancelled = false;
    const load = () => {
      activityClient.onlineCount().then((value) => {
        if (!cancelled) setCount(value);
      });
    };
    load();
    const id = setInterval(load, POLL_MS);
    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, []);

  return count;
}

export function useActivityFeed(limit = 10): ActivityEvent[] {
  const [events, setEvents] = useState<ActivityEvent[]>([]);

  useEffect(() => {
    let cancelled = false;
    const load = () => {
      activityClient.feed(limit).then((value) => {
        if (!cancelled) setEvents(value);
      });
    };
    load();
    const id = setInterval(load, POLL_MS);
    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, [limit]);

  return events;
}
